import script from "./leftPie4.vue?vue&type=script&setup=true&lang=js"
export * from "./leftPie4.vue?vue&type=script&setup=true&lang=js"

import "./leftPie4.vue?vue&type=style&index=0&id=fc29f8ec&scoped=true&lang=css"
script.__scopeId = "data-v-fc29f8ec"

export default script